import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Icon, UserAvatar, Table, DLMenu } from 'appSrc/components/UI';
import { Link } from 'react-router-dom';
import style from './styles/style.module.css';

class FeaturedUsersTable extends PureComponent {
    render() {
        const { users } = this.props;

        return (
            <Table>
                <Table.Head>
                    <Table.Row draggable={ false }>
                        <Table.Cell></Table.Cell>
                        <Table.Cell></Table.Cell>
                        <Table.Cell>DISPLAY NAME</Table.Cell>
                        <Table.Cell>PRO TITLE</Table.Cell>
                        <Table.Cell>ACTIVATED</Table.Cell>
                        <Table.Cell>ACTIONS</Table.Cell>
                    </Table.Row>
                </Table.Head>
                <Table.SortableBody onChange={ this.props.onChange }>
                    { this.arrayTableRows( users ) }
                </Table.SortableBody>
            </Table>
        );
    }

    arrayTableRows = ( users ) => {

        var rows = users.map( ( user, index ) => {
            var individualSlug = `/admin/users/${ user.userid }`;
            return (
                <Table.Row key={ user.userid }>
                    <Table.Cell className='handle' style={ { cursor: 'grab' } }>
                        <Icon source='fontAwesome' icon='fas/faArrowsAltV' style={ { color: 'inheirit' } } />
                    </Table.Cell>
                    <Table.Cell>
                        <Link to={ individualSlug }>
                        </Link>
                        <UserAvatar src={ user.avatar } size={ 40 }
                            style={ { marginRight: '0' } } />
                    </Table.Cell>
                    <Table.Cell>
                        <Link to={ individualSlug }>
                        </Link>
                        { user.displayName }
                    </Table.Cell>
                    <Table.Cell>
                        <Link to={ individualSlug }>
                        </Link>
                        { user.profession.title }
                    </Table.Cell>
                    <Table.Cell className={ style.actionsCell }>
                        <Link to={ individualSlug }>
                        </Link>
                        <Icon source='fontAwesome' icon='fas/faCircle' style={ { color: user.deactivated ? 'red' : 'blue' } } />
                    </Table.Cell>
                    <Table.Cell className={ style.actionsCell }>
                        <DLMenu
                        icon={ ( <Icon source='fontAwesome' className='dropdown' icon='fas/faEllipsisH' style={ { color: '#6461ec' } } faSize='2x' /> ) }
                        direction='left' >
                            <DLMenu.Item text='Edit'
                            onClick={ () => {
                                this.props.openEditModal( index, user );
                            } }/>
                            <DLMenu.Item text={ user.deactivated ? 'Activate' : 'Deactivate' }
                            onClick={ () => {
                                this.props.updateUser( index, user.userid, {
                                    deactivated: !user.deactivated,
                                    displayName: user.displayName,
                                } );
                            } }/>
                            <DLMenu.Item text={ user.featured ? 'UnFeature' : 'Feature' }
                            onClick={ () => {
                                this.props.updateUser( index, user.userid, {
                                    featured: !user.featured,
                                    displayName: user.displayName,
                                } );
                            } }/>
                        </DLMenu>
                    </Table.Cell>
                </Table.Row>
            );
        } );

        return rows;
    }
}

export default connect()( FeaturedUsersTable );
